import React, { useState, useEffect } from 'react';

const Questions = ({
  questions,
  currentQuestion,
  timer,
  isLastQuestion,
  handleAnswerClick,
  handleNextQuestion,
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);

  const question = questions[currentQuestion];

  // Reset local answer state when question changes
  useEffect(() => {
    setSelectedAnswer(null);
  }, [currentQuestion]);

  if (!question) return null;

  const onSelect = (option) => {
    if (selectedAnswer) return;      // lock in first choice
    setSelectedAnswer(option);
    handleAnswerClick(option);       // report up for scoring
  };

  return (
    <div className="container mt-3">
      <div className="card-body">
        <p className="mt-2 text-warning">Time remaining: {timer}s</p>

        <h4 className="card-text">{question.question}</h4>

        <div className="list-group">
          {question.options.map((option, index) => {
            let backgroundColor = 'white';
            if (selectedAnswer) {
              if (option === question.answer) backgroundColor = 'lightgreen';
              else if (option === selectedAnswer) backgroundColor = 'lightcoral';
            }

            return (
              <button
                key={index}
                className="list-group-item list-group-item-action mt-2"
                onClick={() => onSelect(option)}
                style={{ backgroundColor, border: '1px solid gray' }}
                disabled={!!selectedAnswer}
              >
                {option}
              </button>
            );
          })}
        </div>

        <br />

        <div className="row align-items-center">
          <div className="col">
            <p className="card-title mb-0">
              Question {currentQuestion + 1} of {questions.length}
            </p>
          </div>
          <div className="col text-end">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => handleNextQuestion()}
              disabled={!selectedAnswer && timer > 0}
            >
              {isLastQuestion ? 'Submit' : 'Next Question'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Questions;